import { PropsWithChildren, RefObject } from 'react';

type Props = {
  id: string;
  label: string;
  ref?: RefObject<HTMLDivElement | null>;
  className?: string;
} & PropsWithChildren;

export default function QuantitieInputRoot({
  id,
  label,
  ref,
  children,
  className,
}: Props) {
  return (
    <div className={className} ref={ref}>
      <div className="relative">
        <span className="text-sm text-gray-700 leading-[1.8] w-fit">
          {label}
        </span>
        {children}
      </div>
    </div>
  );
}
